import { AsyncPipe, NgClass, NgFor } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FeasibilityRuleSimple } from 'src/app/models/FeasibilityRuleSimple';
import { FreelancerRequestDetailFeasibilityService } from '../../freelancer-request-detail-feasibility/freelancer-request-detail-feasibility.service';

@Component({
    selector: 'app-feasibility-rules-table',
    standalone: true,
    imports: [
        TranslateModule,
        NgFor,
        NgClass,
        AsyncPipe
    ],
    templateUrl: './feasibility-rules-table.component.html',
    styleUrl: './feasibility-rules-table.component.scss'
})
export class FeasibilityRulesTableComponent {
    readonly freelancerRequestDetailFeasibilityService = inject(FreelancerRequestDetailFeasibilityService);

    @Input({ required: true }) feasibilityRules: FeasibilityRuleSimple[];
}
